import { Injectable } from '@angular/core';
import { LocalStorageService } from './localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class EasyEatHqService {
  isHQActive: boolean = false;
  hqOutletList = [];
  constructor(private _localStorage: LocalStorageService) {}

  changeStatus() {
    this.isHQActive = !this.isHQActive;
  }
  updateHQOutletList(list) {
    this.hqOutletList = list;
  }
  isHqUser(): boolean {
    if (
      localStorage.getItem('ee_user_type') === 'rest_hq_admin' ||
      localStorage.getItem('ee_user_type') === 'rest_hq_staff'
    ) {
      this.isHQActive = true;
    } else this.isHQActive = false;
    return this.isHQActive;
  }
  get hqStatus() {
    return this.isHQActive;
  }
  get hqOutletsList() {
    return JSON.parse(localStorage.getItem('ee_outlets'));
  }

  getOutletList() {
    return this.readOutlets('ee_outlets').map((outlet) => ({
      name: outlet?.name,
      id: outlet?.id,
    }));
  }

  getCustomerDisplayOutlets() {
    const hqSettings = this.readOutletsObject('hq_settings');
    const isKioskHq = hqSettings?.global?.is_kiosk_hq == 1;
    const primary = this.readOutlets(
      isKioskHq ? 'ee_outlets' : 'staff_centre_outlets'
    );
    const outlets = primary.length ? primary : this.readOutlets('ee_outlets');
    return outlets
      .filter((outlet) => outlet?.id)
      .map((outlet) => ({
        name: outlet?.name,
        id: outlet?.id,
      }));
  }

  private readOutlets(key: string): any[] {
    const value = this.readOutletsObject(key);
    return Array.isArray(value) ? value : [];
  }

  private readOutletsObject(key: string): any {
    try {
      return JSON.parse(this._localStorage.get(key) || '[]');
    } catch {
      return [];
    }
  }
}
